"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayDebugInfo = displayDebugInfo;
const taskStore_1 = require("../../../taskStore");
const taskSetup_1 = require("../../taskSetup");
function isRealTrial(trial) {
    return (trial.assessment_stage &&
        trial.assessment_stage !== 'practice_response' &&
        trial.assessment_stage !== 'instructions');
}
function displayDebugInfo(stim) {
    if ((0, taskStore_1.taskStore)().debug && (0, taskStore_1.taskStore)().runCat) {
        const lastRealTrial = taskSetup_1.jsPsych.data.get().filterCustom(isRealTrial).last().values()[0];
        const thetaEstimate = taskSetup_1.cat.theta;
        const currentTrialDifficulty = stim.difficulty;
        const CurrentTrialUid = stim.itemUid;
        let previousResponse = 'N/A';
        if ((lastRealTrial === null || lastRealTrial === void 0 ? void 0 : lastRealTrial.correct) !== undefined) {
            previousResponse = lastRealTrial.correct ? 'Correct' : 'Incorrect';
        }
        const thetaEstimateContainer = document.createElement('div');
        thetaEstimateContainer.classList.add('theta-estimate-container');
        thetaEstimateContainer.innerHTML = `
          <p>Theta estimate: ${thetaEstimate}</p>
          <p>Previous response: ${previousResponse}</p>
          <p>Current trial difficulty: ${currentTrialDifficulty}</p>
          <p>Current trial UID: ${CurrentTrialUid}</p>
        `;
        document.body.appendChild(thetaEstimateContainer);
    }
}
